// 创建vue实例
import Vue from "vue";
import App from "./App.vue";
import createrouter from "./router";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/common.css' // 全局css
import VueI18n from 'vue-i18n'
import axios from '@/api/api.js'
import Vuex from 'vuex'
import {baseUrl} from './config/config'
import Vant from 'vant';
import 'vant/lib/index.css';
import headMixin from './mixin/head.js';


Vue.prototype.axios = axios;//设为全局变量，使用this.axios...访问
Vue.prototype.baseUrl = baseUrl;

//全局混入
Vue.mixin(headMixin);

Vue.use(Vant);
Vue.use(Vuex)
Vue.use(VueI18n)
Vue.use(ElementUI)
Vue.config.productionTip = false

const i18n = new VueI18n({
	locale: 'en', // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
	messages: {
		'zh': require('./i18n/language-zh'),  //
		'en': require('./i18n/language-en')
	}
})
//注册为全局组件
Vue.use(i18n)


export function createStore () {
	return new Vuex.Store({
		state: {
			text: "",		//获取count: this.$store.state.text
			text1: "",
		},
		mutations: {
			page (state, text) {//调用该方法: this.$store.commit('page')
				state.text = text
			},
			page1 (state, text) {//调用该方法: this.$store.commit('page1')
				state.text1 = text
			}
		}
	})
}


export default function createApp() {
	const router = createrouter();
	const store = createStore();
	const app = new Vue({
		router,
		i18n,
		store: store,
		render: h => h(App),
	});
	return { app, router , store, i18n};
}
